import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-6" }
const _hoisted_3 = { class: "card card-flush" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("AGENTCODE: ")
const _hoisted_7 = { class: "text-primary" }
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("AGENTID: ")
const _hoisted_10 = { class: "text-primary" }
const _hoisted_11 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("DEFENSILSEC: ")
const _hoisted_13 = { class: "text-primary" }
const _hoisted_14 = {
  key: 0,
  class: "col-xxl-6"
}
const _hoisted_15 = { class: "card card-flush" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "mt-4" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("URL: ")
const _hoisted_19 = { class: "text-primary" }
const _hoisted_20 = { class: "mt-3" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("METHOD: ")
const _hoisted_22 = { class: "text-primary" }
const _hoisted_23 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Content-Type: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "application/json")
], -1)
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("ApiManual.ApiAccount")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", null, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$store.state.AuthModule.user.agent), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", null, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$store.state.AuthModule.user.id), 1)
            ])
          ]),
          (_ctx.type === 'live')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("label", null, [
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$store.state.AuthModule.user.snowsec), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (!_ctx.noaddress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("ApiManual.ApiURL")), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", null, [
                  _hoisted_18,
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.url), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", null, [
                  _hoisted_21,
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.method), 1)
                ])
              ]),
              (_ctx.type === 'live')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}